import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';


import {environment} from '../../../environments/environment';
import { IPoll } from 'projects/lib-ui/src/shared/interfaces/poll';
import { IResponse } from 'projects/lib-ui/src/shared/interfaces/response';
import { IPollResponse } from 'projects/lib-ui/src/shared/interfaces/poll-responses';

@Injectable({
  providedIn: 'root',
})
export class PollService {
  private readonly URI_API = environment.URLAPI;

  constructor(private readonly httpClient: HttpClient) {
  }

  getPollById(pollId: string): Observable<IResponse<IPoll> | { data: IPoll; success: boolean; message: string; }> {
    return this.httpClient.get<IResponse<IPoll>>(
      `${this.URI_API}Poll/${pollId}`
    ).pipe(
      catchError((error) => {
        console.error('Error fetching poll by ID:', error);
        return throwError(() => error);
      })
    );
  }

  sendPollResponse(
    pollResponse: IPollResponse
  ): Observable<IResponse<boolean> | { data: boolean; success: boolean; message: string; }> {
    return this.httpClient.post<IResponse<boolean>>(
      `${this.URI_API}PollSubmission`,
      pollResponse
    ).pipe(
      catchError((error) => {
        console.error('Error sending poll response:', error);
        return throwError(() => error);
      })
    );
  }
}
